function ContactMap() {
    return (
        <div id="map" className="section py-2 bg-body">
            <div style={{ display: 'block', width: '80%', margin: 'auto', marginBottom: '50px', }}>
                <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3443.752395142563!2d76.3906083!3d30.32956!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x391028ecc0000001%3A0xa6073e88b7307a85!2sVIABLE+INFORMATICS+CLUES+PVT.+LTD!5e0!3m2!1sen!2sin!4v1543294550056" style={{ width: ' 100%', height: '400px', border: '0' }} allowFullScreen="" ></iframe>
            </div>
        </div>
        //   border: 'solid 2px #D0DDF5', borderRadius: '8px',
    )
    
}
export default ContactMap;